<template>
  <div>

    <div v-if="view" class="col-md-8 col-md-offset-2">
      <div class="general-active-section">
      <h3 class="text-center">{{computeCaption(fields_en['results'], $store.state.lang.value.toLowerCase())}}</h3><br>
      <div
        v-for="items in dummyArray"
        :key="items['data']['confirmation_number']"
        class="pb-40 col-xs-offset-left-1 col-xs-offset-right-1"
      >
        <div
          class="bg-color p-10 rounded"
          @click.stop.prevent="changeTab(items['data']['confirmation_number'])"
        >
          <div class="row">
            <div class="col-md-2 display-mobile-none">
              <div class="text-center">
                <div v-if="items.data.status === 'pending'">
                    <img src="static/img/pending icon.png" class="image"><br/>
                  <p>{{computeCaption(fields_en['pending'], $store.state.lang.value.toLowerCase())}}</p>
                </div>
                <div v-if="items.data.status === 'rejected'">
                  <img src="static/img/rejected icon.png" class="image"><br/>
                  <p>{{computeCaption(fields_en['rejected'], $store.state.lang.value.toLowerCase())}}</p>
                </div>
                <div v-if="items.data.status === 'cancelled'">
                  <img src="static/img/rejected icon.png" class="image">
                  <p>{{computeCaption(fields_en['cancelled'], $store.state.lang.value.toLowerCase())}}</p>
                </div>
                <div v-if="items.data.status === 'approved'">
                  <img src="static/img/approved icon.png" class="image">
                  <p>{{computeCaption(fields_en['approved'], $store.state.lang.value.toLowerCase())}}</p>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-4 display-bigger-screen-none">
              <div class="text-center">
                <p class="fs-12">
                  <span class="fs-18">{{ items["data"]["day"] }} </span><br />
                  {{computeCaption(items["data"]["month"], $store.state.lang.value.toLowerCase())}}
                </p>
              </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6">
              <p class="fs-18 pt-15 display-mobile-none">
                {{computeCaption(fields_en['patient_name'], $store.state.lang.value.toLowerCase())}} 
                {{ items["data"]["firstName"] + " " + items["data"]["lastName"] }}
              </p>
              <p class="fs-12 pt-15 display-bigger-screen-none">
                {{ items["data"]["firstName"] + " " + items["data"]["lastName"] }}
              </p>
            </div>
            <div class="col-md-3 display-mobile-none">
              <div class="text-center pt-3">
                <p class="">
                  <span class="fs-26">{{ items["data"]["day"] }} </span><br />
                  {{computeCaption(items["data"]["month"], $store.state.lang.value.toLowerCase())}}
                </p>
              </div>
            </div>
            <div class="col-md-1 col-sm-2 col-xs-2 pt-6 ml-20">
              <a
                v-if="moreInfoButton !== items['data']['confirmation_number']"
                @click.stop.prevent="
                  moreInfoButton = items['data']['confirmation_number']
                "
                class="turnGreen float-mobile"
                ><i class="el-icon-arrow-down float-right icon-button"></i
              ></a>
              <a
                v-if="moreInfoButton === items['data']['confirmation_number']"
                @click.stop.prevent="moreInfoButton = ''"
                class="turnGreen float-mobile"
                ><i class="el-icon-arrow-up float-right icon-button"></i
              ></a>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-xs-4 display-bigger-screen-none">
              <div class="text-center">
                <div v-if="items.data.status === 'pending'">
                  <img src="static/img/pending icon.png" class="image">
                  <p>{{computeCaption(fields_en['pending'], $store.state.lang.value.toLowerCase())}}</p>
                </div>
                <div v-if="items.data.status === 'rejected'">
                  <img src="static/img/pending icon.png" class="image">
                  <p>{{computeCaption(fields_en['rejected'], $store.state.lang.value.toLowerCase())}}</p>
                </div>
                <div v-if="items.data.status === 'cancelled'">
                  <img src="static/img/rejected icon.png" class="image">
                  <p>{{computeCaption(fields_en['cancelled'], $store.state.lang.value.toLowerCase())}}</p>
                </div>
                <div v-if="items.data.status === 'approved'">
                  <img src="static/img/approved icon.png" class="image">
                  <p>Approv{{computeCaption(fields_en['approved'], $store.state.lang.value.toLowerCase())}}</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xs-6 display-bigger-screen-none">
              <div class="">
                <div>
                  <p class="fs-12 pt-15">{{computeCaption(fields_en['confirmation_number'], $store.state.lang.value.toLowerCase())}} <br> {{items['data']['confirmation_number'] }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <transition name="fade">

          <div
            v-if="
              moreInfoButton === items['data']['confirmation_number'] &&
                items['data']['actual_results']['name'] !== 'TBD'
            "
            class="row bg-color-white result-container"
          >
            <p class="result" v-html="items['result']"></p>
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="
              moreInfoButton === items['data']['confirmation_number'] &&
                items['data']['actual_results']['name'] === 'TBD'
            "
          >
            <barcode :value="items['data']['kit_number']" v-if="items['data']['kit_number'] && displayKitNumber" class="text-center" format="CODE128">
              Show this if the rendering fails.
            </barcode>
            <barcode :value="items['data']['confirmation_number']" v-else class="text-center" format="CODE128">
                  Show this if the rendering fails.
            </barcode>
            <h3 class="text-center" v-if="items.data.status === 'rejected'">{{computeCaption(fields_en['rejected_results'], $store.state.lang.value.toLowerCase())}}</h3>
            <h3 class="text-center" v-else>
              {{computeCaption(fields_en['pending_results'], $store.state.lang.value.toLowerCase())}}
            </h3>
          </div>
        </transition>
      </div>
      </div>
      <div class="text-right">
        <button
          class="btn btn-default btn-wd btn-back primary-color"
          v-on:click.stop.prevent="$router.push({ path: '/patient/account' })"
          ><span>{{computeCaption(fields_en['back'], $store.state.lang.value.toLowerCase())}}</span></button
        >
      </div><br><br>
    </div>
    <div v-else v-loading.fullscreen.lock="!view" class="loading"></div>
  </div>
</template>

<script>
  import {mapFields} from 'vee-validate'
  import axios from 'axios'
  import {Button} from 'element-ui'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import VueBarcode from 'vue-barcode'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {SettingsUtils} from '../../../../../utils/SiteConfigurations'

  export default {
    components: {
      [Button.name]: Button,
      'barcode': VueBarcode
    },
    mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, SettingsUtils],
    data () {
      return {
        view: false,
        moreInfoButton: '',
        errorData: '',
        dummyArray: this.$store.state.clientResults,
        displayKitNumber: false,
        model: {
          email: '',
          password: ''
        },
        fields_en: {
          pending_results: 'Pending Results',
          results: 'Results',
          back: 'Back',
          email: 'Email',
          password: 'Password',
          pending: 'Pending',
          rejected: 'Rejected',
          approved: 'Approved',
          cancelled: 'Cancelled',
          patient_name: 'Patient Name:',
          confirmation_number: 'Confirmation Number',
          rejected_results: 'Rejected Results'
        },
        modelValidations: {
          email: {
            required: true,
            email: true
          },
          password: {
            min: 8,
            required: true
          }
        }
      }
    },
    async beforeMount () {
      let one = process.env.SERVER_URI + '/account/get/results'
      let two = process.env.SERVER_URI + '/validate/site/' + this.$store.state.sitecode
      const requestOne = axios.post(one, {'email': localStorage.getItem('email')}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      const requestTwo = axios.get(two)
      await axios.all([requestOne, requestTwo]).then(axios.spread((...responses) => {
        if (responses[1].data === false) {
          this.view = false
        } else {
          this.overwriteGraphSettings(responses[1].data)
        }
        this.$store.state.clientResults = responses[0].data
        this.view = true
      })).catch(error => {
        console.log(error)
        this.view = false
      })
      let dateFormat = this.$store.state.configs['DATE_FORMAT'] === undefined ? 'm/d/y' : this.$store.state.configs['DATE_FORMAT'].substring(0, 5)
      let entry
      for (entry in this.$store.state.clientResults) {
        if (this.$store.state.clientResults[entry].data.collection_date) {
          if (this.$store.state.clientResults[entry].data.actual_results.name === 'TBD') {
            this.$store.state.clientResults[entry].data.day = this.$store.state.clientResults[entry].data.collection_date.substring(3, 5)
            this.$store.state.clientResults[entry].data.month = this.$store.state.clientResults[entry].data.collection_date.substring(0, 2)
          } else {
            let dayPos = dateFormat.indexOf('d')
            let monthPos = dateFormat.indexOf('m')
            this.formatDayMonth(dayPos, monthPos, entry)
          }
          switch (this.$store.state.clientResults[entry].data.month) {
            case '01':
              this.$store.state.clientResults[entry].data.month = 'January'
              break
            case '02':
              this.$store.state.clientResults[entry].data.month = 'February'
              break
            case '03':
              this.$store.state.clientResults[entry].data.month = 'March'
              break
            case '04':
              this.$store.state.clientResults[entry].data.month = 'April'
              break
            case '05':
              this.$store.state.clientResults[entry].data.month = 'May'
              break
            case '06':
              this.$store.state.clientResults[entry].data.month = 'June'
              break
            case '07':
              this.$store.state.clientResults[entry].data.month = 'July'
              break
            case '08':
              this.$store.state.clientResults[entry].data.month = 'August'
              break
            case '09':
              this.$store.state.clientResults[entry].data.month = 'September'
              break
            case '10':
              this.$store.state.clientResults[entry].data.month = 'October'
              break
            case '11':
              this.$store.state.clientResults[entry].data.month = 'November'
              break
            case '12':
              this.$store.state.clientResults[entry].data.month = 'December'
              break
            default:
              // code block
          }
        }
        if (this.$store.state.clientResults[entry].data.actual_results.name === 'TBD' || this.$store.state.clientResults[entry].data.pending) {
          this.$store.state.clientResults[entry].data.status = 'pending'
        } else {
          this.$store.state.clientResults[entry].data.status = 'approved'
        }
        if (this.$store.state.clientResults[entry].data.rejected === 'Y') {
          this.$store.state.clientResults[entry].data.status = 'rejected'
        }
        if (this.$store.state.clientResults[entry].data.cancelled) {
          this.$store.state.clientResults[entry].data.status = 'cancelled'
        }
      }
      this.dummyArray = this.$store.state.clientResults
      if (this.$store.state.configs.DISPLAY_KIT_NUMBER_ON_RESULTS) {
        this.displayKitNumber = this.$store.state.configs.DISPLAY_KIT_NUMBER_ON_RESULTS
      }
    },
    methods: {
      formatDayMonth (day, month, index) {
        if (day === 0) {
          this.$store.state.clientResults[index].data.day = this.$store.state.clientResults[index].data.collection_date.substring(0, 2)
        }
        if (day === 2) {
          this.$store.state.clientResults[index].data.day = this.$store.state.clientResults[index].data.collection_date.substring(3, 5)
        }
        if (day === 4) {
          this.$store.state.clientResults[index].data.day = this.$store.state.clientResults[index].data.collection_date.substring(6, 8)
        }
        if (month === 0) {
          this.$store.state.clientResults[index].data.month = this.$store.state.clientResults[index].data.collection_date.substring(0, 2)
        }
        if (month === 2) {
          this.$store.state.clientResults[index].data.month = this.$store.state.clientResults[index].data.collection_date.substring(3, 5)
        }
        if (month === 4) {
          this.$store.state.clientResults[index].data.month = this.$store.state.clientResults[index].data.collection_date.substring(6, 8)
        }
      },
      changeTab (id) {
        if (this.moreInfoButton === id) {
          this.moreInfoButton = ''
        } else {
          this.moreInfoButton = id
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async validate () {
        await this.$validator.validateAll()
        if (this.$validator.errors.items.length) {
          document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
          return false
        }
        return new Promise((resolve, reject) => {
          axios.post(process.env.SERVER_URI + '/login', this.model)
          .then(async (response) => {
            if (response.data === 'Incorrect username or password.') {
              this.errorData = 'Incorrect username or password.'
              reject(new Error('Incorrect username or password.'))
            } else {
              localStorage.setItem('token', response.data)
              resolve(true)
              this.$router.push({ path: '/' })
            }
          }).catch(() => {
            this.errorData = 'Invalid Data or server issues!'
            reject(new Error('Invalid Data or server issues!'))
          })
        })
      }
    },
    computed: {
      ...mapFields(['email', 'password'])
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";

.image {
  width: 30px;
  height: 30px;
  padding-top: 0%;
}
.el-select--large {
  width: 100%;
}

.turnGreen {
  color: $primary-color !important;
}

.bg-color {
  background-color: white;
}

.text-green {
  color: $primary-color;
}

.p-10 {
  padding-top: 8px;
  padding-bottom: 1px;
  padding-right: 3px;
  padding-left: 3px;
}

.pb-40 {
  padding-bottom: 40px;
}

.pt-15 {
  padding-top: 15px;
}

.pt-4 {
  padding-top: 4px;
}

.pt-3{
  padding-top: 3px;
}

.pt-6 {
  padding-top: 6px;
}

.ml-10 {
  margin-left: 10px;
}

.result {
  text-align: center;
  font-size: 20px;
}

.result-container {
  min-height: 600px;
}

.icon {
  color: $primary-color;
  font-size: 20px;
}

.icon-button {
  font-size: 40px;
}

.rounded {
  border: 1px solid $default-grey;
  border-radius: 3px;
}

.fs-12 {
  font-size: 12px;
}

.fs-26 {
  font-size: 26px !important;
}

.fs-18 {
  font-size: 18px;
}

.ml-20 {
  margin-left: -20px;
}

.col-xs-offset-left-1 {
  margin-left: 8.33333333%;
}

.col-xs-offset-right-1 {
  margin-right: 8.33333333%;
}

.display-bigger-screen-none {
  display: none;
}
.text-right {
  float:right;
  margin-top:20px;
  margin-bottom: 20px;
}
@media screen and (max-width: 990px) {
  .result-container {
    min-height: 650px;
  }
  .display-bigger-screen-none {
    display: block;
  }
  .display-mobile-none {
    display: none;
  }
  .float-mobile {
    float: right;
  }
  .fs-12 {
    padding-top: 15px;
  }
  .image {
    width: 30px;
    height: 30px;
    object-fit: contain;
    object-position: center;
  }
}

@media screen and (max-width: 450px) {
  .result-container {
    min-height: 750px;
  }

  .display-bigger-screen-none {
    display: block;
  }

  .icon-button {
    font-size: 35px;
  }

  .display-mobile-none {
    display: none;
  }

  .float-mobile {
    float: right;
  }
}

.fade-enter-active {
  transition: opacity 0.5s ease;
}

.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/ResultsPanel.vue